
import React from 'react';

const Introduction = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
      <div className="space-y-4">
        <p className="text-gray-600">
          We, AI Brainvisuals AG (hereinafter «AIB», «we», «us», «our»), take the protection of your personal data seriously and would like to inform you hereinafter about data protection in our company through this privacy policy.
        </p>
        <p className="text-gray-600">
          As a result of the introduction of the European General Data Protection Regulation (hereinafter "EU-GDPR"), we have been given additional responsibilities to ensure the protection of personal data of the data subject within the scope of our data protection responsibilities.
        </p>
        <p className="text-gray-600">
          To the extent that we either alone or jointly with others decide on the purposes and means of data processing, this includes in particular the obligation to inform you in a transparent manner about the nature, scope, purpose, duration and legal basis of the processing (cf. Art. 13 and 14 EU-GDPR). With this privacy policy, we inform you about how your personal data is processed by us.
        </p>
        <p className="text-gray-600">
          Our privacy policy is modular in structure. It consists of a general part for any processing of personal data and processing situations that come into effect with each call of a web page (A. General) and a special part, the content of which only relates to the processing situations indicated there with the designation of the respective offer or product, especially the visit to our websites and apps as described in more detail here (Part B. Visiting the Website, App and social media presence) as well as data processing operations (C.-H.).
        </p>
      </div>
    </section>
  );
};

export default Introduction;

